module.exports = __webpack_public_path__ + "static/media/uoa-15.d8056941.jpg";